import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Mail, MapPin, Phone } from 'lucide-react';
import { brand } from '../mock';

export default function Footer() {
  return (
    <footer className="bg-navy text-blue-100/80 pt-16 pb-6 mt-8" style={{ backgroundColor: '#061228' }}>
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid md:grid-cols-4 gap-10">
        <div>
          <img
            src="/logo.png"
            alt={brand.name}
            className="h-20 w-auto object-contain mb-4"
          />
          <p className="text-sm leading-relaxed">{brand.tagline} — A trusted Varanasi-based travel partner curating spiritual, leisure & corporate journeys across India.</p>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-4">Quick Links</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="hover:text-orange-400">Home</Link></li>
            <li><Link to="/packages" className="hover:text-orange-400">All Packages</Link></li>
            <li><Link to="/about" className="hover:text-orange-400">About Us</Link></li>
            <li><a href="/#vehicles" className="hover:text-orange-400">Our Fleet</a></li>
            <li><a href="/#contact" className="hover:text-orange-400">Contact</a></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-4">Popular Yatras</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/packages/varanasi-spiritual" className="hover:text-orange-400">Varanasi Spiritual</Link></li>
            <li><Link to="/packages/ayodhya-darshan" className="hover:text-orange-400">Ayodhya Darshan</Link></li>
            <li><Link to="/packages/char-dham-yatra" className="hover:text-orange-400">Char Dham Yatra</Link></li>
            <li><Link to="/packages/vaishno-devi" className="hover:text-orange-400">Vaishno Devi Yatra</Link></li>
            <li><Link to="/packages/kathmandu-pokhara" className="hover:text-orange-400">Nepal Kathmandu–Pokhara</Link></li>
            <li><Link to="/packages/kerala-backwaters" className="hover:text-orange-400">Kerala Backwaters</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-4">Get in Touch</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex gap-2"><MapPin className="w-4 h-4 mt-0.5 text-orange-400 shrink-0" /><span>{brand.address}</span></li>
            <li className="flex gap-2"><Phone className="w-4 h-4 mt-0.5 text-orange-400 shrink-0" /><span>{brand.phone1}<br />{brand.phone2}</span></li>
            <li className="flex gap-2"><Mail className="w-4 h-4 mt-0.5 text-orange-400 shrink-0" /><a href={`mailto:${brand.email}`} className="hover:text-orange-400">{brand.email}</a></li>
            <li><a href={brand.facebook} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 hover:text-orange-400"><Facebook className="w-4 h-4" /> Facebook Page</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 mt-12 pt-6 text-center text-xs text-blue-100/50">
        © {new Date().getFullYear()} {brand.name}. All rights reserved. Website designed with ♥ for travellers.
      </div>
    </footer>
  );
}
